import {
  EnvironmentName,
  EnvironmentSpecificEnv,
} from './environment-specific.type';

export const environmentSpecificEnv: EnvironmentSpecificEnv = {
  environmentName: EnvironmentName.DEMO,
  production: true,
  // using dev variables as this is not prod ready
  // dev,qa,and stage are using the prod flag right now
  // googleAnalytics: {
  //   id: 'UA-31203397-6',
  //   tag: 'GTM-K8TC847'
  // }
  googleAnalytics: {
    id: 'UA-31203397-3',
    tag: 'GTM-K8TC847',
  },
  recaptchaKey: '6Le-VWUqAAAAAPKHxVndckZ4NKNjSmf_YEN-VbNG',
  oktaClientId: '0oays0uhp0SgyHCNU0x7',
  oktaIssuer: 'https://login.alliancewebs.net/oauth2/auslsd6hlkLAt2VJt0x7',
  splitKey: 'tis0of8qdurk0fhiq6o3matqarev3tk7vhtk',
  showOktaSignInButton: false,
  apiSubDomain: 'demo-api',
};
